import { Site } from '../interfaces/sites';
import { Milliseconds, Url } from '../interfaces/common';

export const isSiteProcessed = (site: Site): boolean => Boolean(site.thumbnail);
export const getRetryStepDelay = (retryStep: number): Milliseconds =>
  (retryStep + 1) * 1000;

export const siteFilter = (search: string) => (site: Site): boolean => {
  if (!isSiteProcessed(site)) {
    return false;
  }

  if (!search) {
    return true;
  }

  return site.url.toLowerCase().includes(search.toLowerCase());
};

export const omitHttp = (url: Url): string =>
  url.replace(/^https?:\/\//, '').replace(/\/$/, '');
